/** Tier-scaled sub-services — keep in sync with sparepe_backend/src/constants/garageServiceClusters.js */
export const CLUSTER_SERVICES_BY_TIER = Object.freeze({
  1: {
    small: ['Engine oil change', 'Oil filter replacement', 'Air filter replacement', 'Cabin filter replacement', 'Fluid top-up', 'Basic inspection', 'Exterior wash', 'Interior vacuum'],
    medium: ['Full scheduled maintenance', 'Complete filter service', 'Complete fluid changes', 'Periodic maintenance package'],
    large: ['Full scheduled maintenance', 'Complete filter and fluid service', 'Seasonal maintenance package'],
  },
  2: {
    small: ['Battery test', 'Battery jump-start', 'Battery terminal clean', 'Battery replacement', 'Headlight bulb replacement', 'Taillight bulb replacement', 'Indicator bulb replacement', 'Wiper blade replacement', 'Horn repair'],
    medium: ['Starter motor repair', 'Alternator repair', 'Power window repair', 'Central locking repair', 'Wiring repair', 'Sensor calibration (O2, MAP, ABS, parking)'],
    large: ['ECU repair (stock)', 'Immobilizer service', 'Infotainment repair', 'ADAS calibration', 'Wiring harness repair'],
  },
  3: {
    small: ['Puncture plug/patch', 'Tube replacement', 'Tyre rotation', 'Nitrogen fill'],
    medium: ['Computerized 2D/3D alignment', 'Dynamic balancing', 'TPMS reset', 'Wheel bearing service'],
    large: ['3D alignment with printout', 'Run-flat tyre replacement', 'Alloy wheel repair', 'Tyre upsize consultation'],
  },
  4: {
    small: ['Brake pad replacement', 'Brake shoe replacement', 'Brake cleaning'],
    medium: ['Disc/drum replacement', 'ABS sensor service', 'Shock absorber replacement', 'Strut replacement', 'Control arm replacement'],
    large: ['Full brake system overhaul', 'Air-ride suspension service', 'Advanced ABS diagnostics'],
  },
  5: {
    small: ['AC gas top-up', 'AC vent cleaning', 'AC cooling check'],
    medium: ['AC compressor repair', 'AC condenser service', 'Evaporator cleaning', 'Full AC gas refill'],
    large: ['Full AC system replacement', 'Compressor overhaul', 'Heater core service', 'Automatic climate control repair'],
  },
  6: {
    small: ['Spark plug replacement', 'Belt adjustment', 'Gasket leak fix', 'Thermostat replacement'],
    medium: ['Timing belt/chain service', 'Head gasket repair', 'Injector cleaning', 'Fuel pump service', 'Turbocharger service', 'Radiator flush', 'Water pump replacement'],
    large: ['Engine overhaul', 'Full engine rebuild', 'Turbocharger overhaul', 'Fuel system overhaul'],
  },
  7: {
    medium: ['Clutch kit replacement', 'Flywheel inspection', 'Hydraulic release bearing', 'Exhaust leak repair'],
    large: ['Manual gearbox overhaul', 'Automatic gearbox overhaul', 'CVT repair', 'Torque converter service', 'Driveshaft service'],
  },
  8: {
    medium: ['Dent removal', 'Scratch repair', 'Windshield crack repair'],
    large: ['Chassis straightening', 'Panel replacement', 'Full body paint', 'Full windshield replacement', 'Sunroof service'],
  },
  9: {
    small: ['PUC/emission certificate', 'Wiper/washer mechanism fix'],
    medium: ['OBD scan and fault code report', 'Insurance claim repair coordination', 'Pre-purchase inspection report'],
    large: ['Advanced diagnostic scan', 'Oscilloscope testing', 'CAN bus analysis', 'ECU programming', 'Full insurance claim handling'],
  },
  10: {
    small: ['CNG/LPG kit basic service', 'CNG/LPG leak test'],
    medium: ['CNG/LPG kit full service', 'CNG/LPG regulator service'],
    large: ['EV/Hybrid high-voltage battery health check', 'EV/Hybrid regen braking service', 'EV/Hybrid motor inspection'],
  },
});
